import React from 'react'

import { TwoColumnBannerAligned } from './TwoColumnBannerAligned'
import { TwoColumnBannerProps } from './TwoColumnBannerColumns'
import { TwoColumnBannerIndependent } from './TwoColumnBannerIndependent'

export type { TwoColumnBannerProps }

export const TwoColumnBanner = (props: TwoColumnBannerProps) => {
  const {
    leftPlaylistId,
    rightPlaylistId,
    leftColumnContent,
    rightColumnContent,
    leftCertificateRates,
    rightCertificateRates
  } = props

  const hasVideo = !!(leftPlaylistId || rightPlaylistId)
  const hasCertificateRates = !!(leftCertificateRates || rightCertificateRates)
  const hasAnyImage =
    leftColumnContent?.includes('<img') || rightColumnContent?.includes('<img')
  const hasAnyTable =
    leftColumnContent?.includes('<table') ||
    rightColumnContent?.includes('<table')

  // Text-only columns use the aligned layout so each content block (eyebrow,
  // body, buttons) lines up row-by-row across the two columns. Images, tables,
  // video, and certificate rate circles have their own intrinsic height and
  // must not be forced onto a shared row grid, so those flow independently.
  const isAligned = !(
    hasAnyImage ||
    hasAnyTable ||
    hasVideo ||
    hasCertificateRates
  )

  return isAligned ? (
    <TwoColumnBannerAligned {...props} />
  ) : (
    <TwoColumnBannerIndependent {...props} />
  )
}
